/**
 * NutraVora Mobile UX Enhancements
 * Touch gestures, scroll behavior, iOS fixes
 * Premium Supplement Brand - v1.0
 */

(function () {
  'use strict';

  const isMobile = window.innerWidth <= 768;
  const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);

  const setVH = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--nv-vh', `${vh}px`);
  };

  setVH();
  window.addEventListener('resize', setVH, { passive: true });

  const labelMerchantReviewIframe = () => {
    const merchantWidgetMobileQuery = window.matchMedia ? window.matchMedia('(max-width: 989px)') : null;
    const isMerchantWidgetMobile = () => (
      merchantWidgetMobileQuery ? merchantWidgetMobileQuery.matches : window.innerWidth <= 989
    );

    const setTitleAndDrawerState = () => {
      const drawerOpen = document.body.classList.contains('nv-cart-drawer-open') ||
        Boolean(document.querySelector('[data-nv-cart-drawer].is-open'));
      const lowerWidgetZIndex = isMerchantWidgetMobile();
      const wrapper = document.getElementById('google-merchantwidget-iframe-wrapper');
      const iframe = document.getElementById('merchantwidgetiframe');

      if (iframe && !iframe.getAttribute('title')) {
        iframe.setAttribute('title', 'Product Reviews and Ratings');
      }

      [wrapper, iframe].forEach((element) => {
        if (!element) return;

        if (element.dataset.nvCartDrawerZIndexValue === undefined) {
          element.dataset.nvCartDrawerZIndexValue = element.style.getPropertyValue('z-index') || '';
          element.dataset.nvCartDrawerZIndexPriority = element.style.getPropertyPriority('z-index') || '';
        }

        if (drawerOpen) {
          element.dataset.nvCartDrawerHidden = 'true';
          element.setAttribute('aria-hidden', 'true');
          element.style.setProperty('display', 'none', 'important');
          element.style.setProperty('visibility', 'hidden', 'important');
          element.style.setProperty('opacity', '0', 'important');
          element.style.setProperty('pointer-events', 'none', 'important');
          element.style.setProperty('z-index', '0', 'important');
          return;
        }

        if (element.dataset.nvCartDrawerHidden === 'true') {
          delete element.dataset.nvCartDrawerHidden;
          element.removeAttribute('aria-hidden');
          element.style.removeProperty('display');
          element.style.removeProperty('visibility');
          element.style.removeProperty('opacity');
          element.style.removeProperty('pointer-events');
        }

        if (lowerWidgetZIndex) {
          element.style.setProperty('z-index', '10', 'important');
          return;
        }

        if (element.dataset.nvCartDrawerZIndexValue) {
          element.style.setProperty(
            'z-index',
            element.dataset.nvCartDrawerZIndexValue,
            element.dataset.nvCartDrawerZIndexPriority || ''
          );
        } else {
          element.style.removeProperty('z-index');
        }
        delete element.dataset.nvCartDrawerZIndexValue;
        delete element.dataset.nvCartDrawerZIndexPriority;
      });
    };

    let updateScheduled = false;
    const scheduleTitleAndDrawerState = () => {
      if (updateScheduled) return;
      updateScheduled = true;
      window.requestAnimationFrame(() => {
        updateScheduled = false;
        setTitleAndDrawerState();
      });
    };

    scheduleTitleAndDrawerState();

    const hasMerchantWidget = () => (
      document.getElementById('google-merchantwidget-iframe-wrapper') &&
      document.getElementById('merchantwidgetiframe')
    );
    if (!hasMerchantWidget()) {
      const discoveryObserver = new MutationObserver(() => {
        scheduleTitleAndDrawerState();
        if (hasMerchantWidget()) discoveryObserver.disconnect();
      });
      discoveryObserver.observe(document.documentElement, {
        childList: true,
        subtree: true
      });
    }

    const drawerStateObserver = new MutationObserver(scheduleTitleAndDrawerState);
    drawerStateObserver.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    document.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : event.target && event.target.parentElement;
      if (!target || !target.closest('[data-nv-cart-drawer-open], [data-nv-cart-drawer-close]')) return;
      scheduleTitleAndDrawerState();
    }, true);

    if (merchantWidgetMobileQuery && typeof merchantWidgetMobileQuery.addEventListener === 'function') {
      merchantWidgetMobileQuery.addEventListener('change', scheduleTitleAndDrawerState);
    } else if (merchantWidgetMobileQuery && typeof merchantWidgetMobileQuery.addListener === 'function') {
      merchantWidgetMobileQuery.addListener(scheduleTitleAndDrawerState);
    } else {
      window.addEventListener('resize', scheduleTitleAndDrawerState, { passive: true });
    }
  };

  labelMerchantReviewIframe();

  const createScrollProgress = () => {
    if (document.getElementById('nv-scroll-progress')) return;

    const bar = document.createElement('div');
    bar.id = 'nv-scroll-progress';
    bar.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      height: 1px;
      width: 100%;
      background: linear-gradient(to right, #315C4A 0%, #C8A96B 100%);
      z-index: 9999;
      transform: scaleX(0);
      transform-origin: left center;
      transition: opacity 0.3s ease;
      will-change: transform;
      pointer-events: none;
    `;
    document.body.prepend(bar);

    let progressUpdateScheduled = false;
    const updateProgress = () => {
      progressUpdateScheduled = false;
      const scrollTop = window.scrollY;
      const docHeight = document.documentElement.scrollHeight - window.innerHeight;
      const progress = docHeight > 0 ? scrollTop / docHeight : 0;
      bar.style.transform = `scaleX(${Math.min(progress, 1)})`;
    };
    window.addEventListener('scroll', () => {
      if (progressUpdateScheduled) return;
      progressUpdateScheduled = true;
      window.requestAnimationFrame(updateProgress);
    }, { passive: true });
  };

  createScrollProgress();

  const mobileMenuBtn = document.querySelector(
    '[data-mobile-menu-toggle], ' +
    '.header__icon--menu, ' +
    '[aria-controls*="menu"]'
  );

  if (mobileMenuBtn) {
    mobileMenuBtn.addEventListener('click', () => {
      document.body.classList.toggle('nv-menu-open');
    });
  }

  const dragScrollEls = document.querySelectorAll(
    '.nv-health-goals__grid, ' +
    '.nv-bundle__products'
  );

  dragScrollEls.forEach(el => {
    let isDown = false;
    let startX = 0;
    let scrollLeft = 0;

    el.addEventListener('mousedown', (event) => {
      isDown = true;
      el.style.cursor = 'grabbing';
      startX = event.pageX - el.offsetLeft;
      scrollLeft = el.scrollLeft;
    });

    el.addEventListener('mouseleave', () => {
      isDown = false;
      el.style.cursor = 'grab';
    });

    el.addEventListener('mouseup', () => {
      isDown = false;
      el.style.cursor = 'grab';
    });

    el.addEventListener('mousemove', (event) => {
      if (!isDown) return;
      event.preventDefault();
      const x = event.pageX - el.offsetLeft;
      const walk = (x - startX) * 1.5;
      el.scrollLeft = scrollLeft - walk;
    });

    el.style.cursor = 'grab';
  });

  const pdpImages = document.querySelectorAll(
    '.product-media-container img, ' +
    '.product__media img'
  );

  pdpImages.forEach(img => {
    img.style.touchAction = 'pinch-zoom';
  });

  const createBackToTop = () => {
    if (document.getElementById('nv-back-to-top')) return;

    const btn = document.createElement('button');
    btn.id = 'nv-back-to-top';
    btn.setAttribute('aria-label', 'Back to top');
    btn.innerHTML = `
      <svg width="16" height="16" viewBox="0 0 24 24"
           fill="none" stroke="currentColor" stroke-width="2.5"
           stroke-linecap="round" stroke-linejoin="round">
        <polyline points="18 15 12 9 6 15"/>
      </svg>
    `;
    btn.style.cssText = `
      position: fixed;
      bottom: 24px;
      right: 20px;
      width: 44px;
      height: 44px;
      border-radius: 50%;
      background: var(--nv-green-primary);
      color: var(--nv-white);
      border: 1px solid #C8A96B33;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 10px 40px rgba(0,0,0,0.05);
      opacity: 0;
      transform: translateY(12px);
      transition: opacity 0.3s ease, transform 0.3s ease;
      z-index: var(--nv-z-sticky);
      pointer-events: none;
    `;

    document.body.appendChild(btn);

    let backToTopUpdateScheduled = false;
    const updateBackToTop = () => {
      backToTopUpdateScheduled = false;
      const show = window.scrollY > 600;
      btn.style.opacity = show ? '1' : '0';
      btn.style.transform = show ? 'translateY(0)' : 'translateY(12px)';
      btn.style.pointerEvents = show ? 'auto' : 'none';
    };
    window.addEventListener('scroll', () => {
      if (backToTopUpdateScheduled) return;
      backToTopUpdateScheduled = true;
      window.requestAnimationFrame(updateBackToTop);
    }, { passive: true });

    btn.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  };

  createBackToTop();

  if (isMobile) {
    const stickyAtc = document.querySelector('.nv-sticky-atc');
    const siteHeader = document.querySelector('.site-header, header[role="banner"]');

    if (stickyAtc && siteHeader) {
      const headerHeight = siteHeader.offsetHeight;
      const headerPosition = getComputedStyle(siteHeader).position;
      const headerIsSticky = headerPosition === 'sticky' || headerPosition === 'fixed';

      if (headerIsSticky) {
        stickyAtc.style.top = `${headerHeight}px`;
      }
    }
  }

  document.addEventListener('modalOpen', () => {
    document.body.style.overflow = 'hidden';
  });

  document.addEventListener('modalClose', () => {
    document.body.style.overflow = '';
  });

  if (isIOS) {
    document.documentElement.style.setProperty('--nv-safe-bottom', 'env(safe-area-inset-bottom, 0px)');

    const stickyAtc = document.querySelector('.nv-sticky-atc');
    if (stickyAtc) {
      stickyAtc.style.paddingBottom = 'env(safe-area-inset-bottom, 0px)';
    }
  }

  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', (event) => {
      const href = anchor.getAttribute('href');
      if (!href || href === '#') return;

      let target;
      try {
        target = document.querySelector(href);
      } catch (error) {
        return;
      }

      if (!target) return;
      event.preventDefault();
      const offset = 80;
      const top = target.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: 'smooth' });
    });
  });
})();
